import { type FC } from 'react';
import { Controller } from 'react-hook-form';
import { type ControllerRenderProps } from 'react-hook-form/dist/types/controller';

import { Control, type ControlOuterProps } from '@/components/common/Control';
import { PhoneInput, type PhoneInputProps } from '@/components/common/input/PhoneInput';

type FormPhoneInputProps = ControlOuterProps &
  Omit<PhoneInputProps, 'state' | keyof ControllerRenderProps> & {
    name: string;
    disabled?: boolean;
  };

export const FormPhoneInput: FC<FormPhoneInputProps> = (props) => {
  const { name, label, className, disabled, ...phoneInputProps } = props;

  return (
    <Controller
      name={name}
      render={({ field, fieldState }) => (
        <Control className={className} label={label} error={fieldState.error?.message}>
          <PhoneInput
            {...phoneInputProps}
            state={fieldState.invalid ? 'error' : 'default'}
            disabled={disabled ?? field.disabled}
            name={field.name}
            value={field.value}
            onChange={field.onChange}
            onBlur={field.onBlur}
          />
        </Control>
      )}
    />
  );
};
